import type { PropType } from 'virtual-vue';
import type { InputType, InputAlign, InputMode } from './input';

export const DEFAULT_INPUT_TYPE = 'text';
export const DEFAULT_INPUT_ALIGN = 'left';

export const props = {
  modelValue: {
    type: [String, Number],
    default: '',
  },

  /** Vue 2 v-model 兼容 */
  value: {
    type: [String, Number],
    default: '',
  },

  type: {
    type: String as PropType<InputType>,
    default: DEFAULT_INPUT_TYPE,
  },

  placeholder: {
    type: String,
    default: '请输入内容',
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  readonly: {
    type: Boolean,
    default: false,
  },

  maxlength: {
    type: Number,
  },

  inputAlign: {
    type: String as PropType<InputAlign>,
    default: DEFAULT_INPUT_ALIGN,
  },

  inputMode: {
    type: String as PropType<InputMode>,
  },

  autofocus: {
    type: Boolean,
    default: false,
  },

  name: {
    type: String,
    default: '',
  },

  /** LiteApp 专属：键盘弹起时是否自动上推页面 */
  adjustPosition: {
    type: Boolean,
    default: false,
  },
};
